import { message } from 'antd';
import { get } from 'lodash';
import {
  fetchOrderCustomerInfo,
  fetchOrderRoomInfo,
  fetchOrderCheckedInList,
  fetchOrderCheckedOutPage,
  fetchOrderReservedList,
  fetchOrderCanceledPage,
  fetchUpdateRoomPrice,
  fetchAddMember,
  fetchUpdateMember,
  fetchUpdateBooker,
  fetchMemberCheckOut,
  fetchOrderDetailBaseInfo,
  fetchUpdateOrderRemark,
  fetchUniteRoomDetail,
  fetchSubmitUniteRoom,
  fetchSplitRoomDetail,
  fetchSubmitSplitRoom,
  fetchBillList,
  fetchLastNightAudit,
  fetchExtendedCheckinDetail,
  fetchUpdateExtendedCheckinDetail,
  fetchSysBusinessDateByTime,
  fetchCheckRoomList,
  fetchApplyCheckRoom,
  fetchVerificationCheckRoom,
  fetchIsStartUseCard,
  fetchIsChangeMaster,
  fetchOtaCancelList,
} from '@/api/order';
import { fetchRoomTypeList } from '@/api/roomManagement';
import { fetchUserAvailbleCardList } from '@/api/guest';
import { IcustomerInfo, IorderItem, IorderQueryItem } from '@/redux/reducers/order';
import { MemberType, SubOrderStatus } from '@/config/constant';
import { isEmptyObject, renderIntlLabel } from '@/utils';
import actionType from './actionType';

export const clearData = (state) => {
  return {
    type: actionType.CLEAR_DATA,
    payload: state,
  };
};

export const saveData = (state) => {
  return {
    type: actionType.SAVE_DATA,
    payload: state,
  };
};

export const toggleLoading = (state) => {
  return {
    type: actionType.TOGGLE_LOADING,
    payload: state,
  };
};

export const setPagination = (state) => {
  return {
    type: actionType.SET_PAGINATION,
    payload: state,
  };
};

export const resetPagination = (state) => {
  return {
    type: actionType.RESET_PAGINATION,
    payload: state,
  };
};

// 直连退单查询
export const getOtaCancelList = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('otaCancelListLoading'));
    let otaOrderMap = {};
    try {
      const res = await fetchOtaCancelList(data);
      if (res.code === 0) {
        otaOrderMap = get(res, 'data', {}) || {};
        dispatch({
          type: actionType.OTA_CANCEL_LIST,
          payload: {
            otaOrderMap,
          },
        });
      }
    } catch (error) {
      //
    } finally {
      dispatch(toggleLoading('otaCancelListLoading'));
    }
  };
};
// 能否更换房主
export const queryIsChangeMaster = (data) => {
  return async (dispatch) => {
    let isChangeMatser = false;
    const res = await fetchIsChangeMaster(data);
    if (res.code === 0) {
      isChangeMatser = get(res, 'data', false);
      dispatch({
        type: actionType.IS_CHANGE_MASTER,
        payload: {
          isChangeMatser,
        },
      });
    }
  };
};

// 是否启用房卡
export const getStoreIsStartUseCard = () => {
  return async (dispatch) => {
    let isStartUseCard = false;
    const res = await fetchIsStartUseCard();
    if (res.code === 0) {
      isStartUseCard = !isEmptyObject(get(res, 'data', {}));
      dispatch({
        type: actionType.STOTE_START_USE_CARD,
        payload: {
          isStartUseCard,
        },
      });
    }
  };
};

export const getExtendedCheckinDetail = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('extendedCheckinDetailLoading'));
    try {
      const res = await fetchExtendedCheckinDetail(data);
      if (res.code === 0) {
        dispatch({
          type: actionType.EXTENDED_CHECKIN_DETAIL_LIST,
          payload: {
            extendedCheckinDetailList: get(res, 'data', ''),
          },
        });
      }
      dispatch(toggleLoading('extendedCheckinDetailLoading'));
    } catch (error) {
      dispatch(toggleLoading('extendedCheckinDetailLoading'));
    }
  };
};

export const updateExtendedCheckinDetail = (data) => {
  return async (dispatch) => {
    const { recNo, ...rest } = data;
    const res = await fetchUpdateExtendedCheckinDetail(rest);
    if (res.code === 0) {
      message.warning(renderIntlLabel('order_msg_info_update_success'));
      dispatch(getExtendedCheckinDetail({ recNo }));
    }
  };
};

export const getSysBusinessDateByTime = (data) => {
  return async (dispatch) => {
    await fetchSysBusinessDateByTime(data);
  };
};

export const getLastNightAudit = () => {
  return async (dispatch) => {
    const res = await fetchLastNightAudit();
    if (res.code === 0) {
      dispatch({
        type: actionType.LAST_NIGHT_AUDIT_TIME,
        payload: {
          lastNightAuditTime: get(res, 'data.completeTime', ''),
        },
      });
    }
  };
};

export const getRoomTypeList = () => {
  return async (dispatch) => {
    try {
      const res = await fetchRoomTypeList();
      if (res.code === 0) {
        const list = get(res, 'data', []);
        const roomTypeDataSource = list?.map((item) => ({ label: item.name, value: item.id }));
        dispatch({
          type: actionType.ROOM_TYPE_DATA_SOURCE,
          payload: {
            roomTypeDataSource,
          },
        });
        return Promise.resolve(roomTypeDataSource);
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    }
  };
};

/** 入住列表 */
export const getOrderCheckedInList = (data?: IorderQueryItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('orderListLoading'));
    let orderList = [];
    try {
      const res = await fetchOrderCheckedInList({ ...data });
      if (res.code === 0) {
        orderList = get(res, 'data', []);
        dispatch({
          type: actionType.ORDER_RECEPTION_LIST,
          payload: {
            orderList,
          },
        });
      }
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(toggleLoading('orderListLoading'));
    }
  };
};

/** 已退房分页 */
export const getOrderCheckedOutPage = (data?: IorderQueryItem) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('orderListLoading'));
    let orderList = [];
    const initialState = getState().order;
    const { pageSize } = initialState;
    let { pageNum, total } = initialState;
    try {
      const res = await fetchOrderCheckedOutPage({
        orderBy: 'checkout_time desc',
        pageNum,
        pageSize,
        ...data,
      });
      if (res.code === 0) {
        orderList = get(res, 'data.list', []);
        pageNum = get(res, 'data.pageNum', 1);
        total = get(res, 'data.total', 0);
      }
    } catch (error) {
      // console.log(error);
      pageNum = 1;
      total = 0;
    } finally {
      dispatch(toggleLoading('orderListLoading'));
      dispatch({
        type: actionType.ORDER_RECEPTION_PAGE,
        payload: {
          orderList,
          pageNum,
          total,
        },
      });
    }
  };
};

/** 预订列表  */
export const getOrderReservedList = (data?: IorderQueryItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('orderListLoading'));
    let orderList = [];
    try {
      const res = await fetchOrderReservedList({ ...data });
      if (res.code === 0) {
        orderList = get(res, 'data', []);
        dispatch({
          type: actionType.ORDER_RESERVATION_LIST,
          payload: {
            orderList,
          },
        });
      }
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(toggleLoading('orderListLoading'));
    }
  };
};

/** 预订取消分页 */
export const getOrderCanceledPage = (data?: IorderQueryItem) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('orderListLoading'));
    let orderList = [];
    const initialState = getState().order;
    const { pageSize } = initialState;
    let { pageNum, total } = initialState;
    try {
      const res = await fetchOrderCanceledPage({
        orderBy: 'update_time desc',
        pageNum,
        pageSize,
        ...data,
      });
      if (res.code === 0) {
        orderList = get(res, 'data.list', []);
        pageNum = get(res, 'data.pageNum', 1);
        total = get(res, 'data.total', 0);
      }
    } catch (error) {
      // console.log(error);
      pageNum = 1;
      total = 0;
    } finally {
      dispatch(toggleLoading('orderListLoading'));
      dispatch({
        type: actionType.ORDER_RESERVATION_PAGE,
        payload: {
          orderList,
          pageNum,
          total,
        },
      });
    }
  };
};

/** 订单详情 */
export const getOrderDetailBaseInfo = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('orderBaseInfoLoading'));
    try {
      const res = await fetchOrderDetailBaseInfo({ ...data });
      if (res.code === 0) {
        dispatch({
          type: actionType.ORDER_DETAIL_BASE_INFO,
          payload: {
            orderBaseInfo: get(res, 'data', {}) || {},
          },
        });
      }
      dispatch(toggleLoading('orderBaseInfoLoading'));
      return Promise.resolve(get(res, 'data', {}) || {});
    } catch (error) {
      dispatch(toggleLoading('orderBaseInfoLoading'));
      return Promise.reject();
    }
  };
};

// 更新门店可售用户可购卡状态
export const updateAllGuestCanBuyCard = (guestList) => {
  return async () => {
    const wyuIds = guestList?.filter((item) => item.wyuid)?.map((item) => item.wyuid);
    if (Array.isArray(wyuIds) && wyuIds.length) {
      try {
        const resonse = await fetchUserAvailbleCardList({ wyuIds });
        if (resonse?.code === 0) {
          const canBuyCardMap = resonse?.data;
          let list = [...guestList];
          list = list.map((item) => {
            const tempItem = { ...item };
            const currentList = canBuyCardMap[tempItem.wyuid];
            if (Array.isArray(currentList) && currentList.length) {
              tempItem.canBuyCard = true;
            }
            return tempItem;
          });
          return Promise.resolve(list);
        }
        return Promise.resolve([]);
      } catch (error) {
        return Promise.resolve([]);
      }
    }
    return Promise.resolve([]);
  };
};

// 宾客详情
export const getOrderCustomerInfo = (data?: IorderItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('orderCustomerInfoLoading'));
    try {
      const res = await fetchOrderCustomerInfo({ ...data });
      if (res.code === 0) {
        const customerInfoList = get(res, 'data.customerInfo', []);
        // 预订人
        const reserveCustomerList = customerInfoList?.filter(
          (item) => item.memberType === MemberType.Booker,
        );
        let checkInCustomerList = customerInfoList?.filter(
          (item) => item.memberType !== MemberType.Booker,
        );
        const customerRoomInfoList = get(res, 'data.customerRoomInfos', []);
        // 入住、已退房
        const checkInRoomInfoList = customerRoomInfoList?.filter(
          (item) =>
            item.status === SubOrderStatus.CheckIn || item.status === SubOrderStatus.CheckOut,
        );
        checkInCustomerList = await dispatch(updateAllGuestCanBuyCard(checkInCustomerList));

        dispatch({
          type: actionType.ORDER_DETAIL_CUSTOMER_INFO,
          payload: {
            sourceChannelType: get(res, 'data.sourceChannelType'),
            reserveCustomerList,
            checkInCustomerList,
            customerRoomInfoList,
            checkInRoomInfoList,
          },
        });
      }
      dispatch(toggleLoading('orderCustomerInfoLoading'));
    } catch (error) {
      dispatch({
        type: actionType.ORDER_DETAIL_CUSTOMER_INFO,
        payload: {
          sourceChannelType: '',
          reserveCustomerList: [],
          checkInCustomerList: [],
          customerRoomInfoList: [],
          checkInRoomInfoList: [],
        },
      });
      dispatch(toggleLoading('orderCustomerInfoLoading'));
    }
  };
};

const getMaxRangeDate = (list) => {
  let rangeDateList = [];
  // 获取最大日期跨度
  list?.forEach((item) => {
    const { rentDayInfos } = item;
    // 同一房间的相同日期出现次数
    const existedSameDateObj = {};
    let tempDateIndex = 0;
    rentDayInfos?.forEach((subItem) => {
      // （取不同房间相同日期数最大的，兼容#同一个钟点房同一天续住产生多条数据），用date+index标记key
      // recNo: 2022-01-01, 2022-03-01, 2022-11-01
      // recNo2: 2022-01-01, 2022-03-01, 2022-03-01
      // result => 2022-01-01, 2022-03-01, 2022-03-01, 2022-11-01
      if (!existedSameDateObj[subItem.rentDate]) {
        existedSameDateObj[subItem.rentDate] = 1;
      } else {
        tempDateIndex = existedSameDateObj[subItem.rentDate];
        existedSameDateObj[subItem.rentDate] += 1;
      }
      rangeDateList.push(`[${subItem.rentDate}].[${tempDateIndex}]`);
    });
  });
  rangeDateList = Array.from(new Set(rangeDateList));
  rangeDateList.sort((a, b) => (a < b ? -1 : 1));
  return rangeDateList;
};

const filterTableData = (list) => {
  const dataSource = [];
  list?.forEach((item) => {
    const { rentDayInfos, deposit, ...rest } = item;
    const dataSourceItem = { ...rest };
    dataSourceItem.id = rest.recNo;
    dataSourceItem.deposit = deposit ? Number((deposit / 100).toFixed(2)) : 0;
    const existedSameDateObj = {};
    let tempDateIndex = 0;
    rentDayInfos?.forEach((subItem) => {
      const temSubItem = { ...subItem };
      temSubItem.couponAmount = subItem.couponAmount
        ? Number((subItem.couponAmount / 100).toFixed(2))
        : 0;
      temSubItem.price = subItem.price ? Number((subItem.price / 100).toFixed(2)) : 0;
      if (!existedSameDateObj[subItem.rentDate]) {
        existedSameDateObj[subItem.rentDate] = 1;
      } else {
        tempDateIndex = existedSameDateObj[subItem.rentDate];
        existedSameDateObj[subItem.rentDate] += 1;
      }
      dataSourceItem[`[${subItem.rentDate}].[${tempDateIndex}]`] = temSubItem.price;
      // key:子单号、日期、日期index，value:优惠券和房价信息
      dataSourceItem[`${rest.recNo}[${subItem.rentDate}].[${tempDateIndex}]`] = temSubItem;
    });
    dataSource.push(dataSourceItem);
  });
  return dataSource;
};

// 房间、房价详情
export const getOrderRoomInfo = (data?: IorderItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('orderRoomInfoLoading'));
    try {
      const res = await fetchOrderRoomInfo({ ...data });
      if (res.code === 0) {
        const roomInfoList = [];
        const temp = get(res, 'data.roomInfos', []);
        temp.forEach((element) => {
          const obj = { ...element };
          obj.id = element.recNo;
          roomInfoList.push(obj);
        });
        const dayRoomPriceInfoList = get(res, 'data.dayUseRoomPriceInfos', []);
        const hourRoomPriceInfoList = get(res, 'data.timeRentRoomPriceInfos', []);
        const dayRangeDateList = getMaxRangeDate(dayRoomPriceInfoList);
        const dayPriceDataSource = filterTableData(dayRoomPriceInfoList);
        const hourRangeDateList = getMaxRangeDate(hourRoomPriceInfoList);
        const hourPriceDataSource = filterTableData(hourRoomPriceInfoList);
        dispatch({
          type: actionType.ORDER_DETAIL_ROOM_INFO,
          payload: {
            roomInfoList,
            dayRangeDateList,
            dayPriceDataSource,
            hourRangeDateList,
            hourPriceDataSource,
          },
        });
      }
      dispatch(toggleLoading('orderRoomInfoLoading'));
    } catch (error) {
      dispatch({
        type: actionType.ORDER_DETAIL_ROOM_INFO,
        payload: {
          roomInfoList: [],
          dayPriceColumns: [],
          dayPriceDataSource: [],
          hourPriceColumns: [],
          hourPriceDataSource: [],
        },
      });
      dispatch(toggleLoading('orderRoomInfoLoading'));
    }
  };
};

// 修改订单备注
export const updateOrderRemark = (data) => {
  return async (dispatch) => {
    const { resvNo, ...rest } = data;
    const res = await fetchUpdateOrderRemark({ ...rest });
    if (res.code === 0) {
      message.success(renderIntlLabel('order_msg_info_update_success'));
      dispatch(getOrderRoomInfo({ resvNo }));
    }
  };
};

// 修改房价、押金
export const updateOrderRoomPrice = (data) => {
  return async (dispatch) => {
    const { resvNo, ...rest } = data;
    const res = await fetchUpdateRoomPrice({ ...rest, resvNo });
    if (res.code === 0) {
      message.success(renderIntlLabel('order_msg_info_update_success'));
    }
    dispatch(getOrderRoomInfo({ resvNo }));
  };
};

/** 订单里入住人、访客、预订人 */
// 添加入住人、访客
export const orderAddMember = (data: IcustomerInfo & IorderItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('addMemberLoading'));
    try {
      const { resvNo, ...rest } = data;
      const res = await fetchAddMember({ resvNo, ...rest });
      if (res.code === 0) {
        message.success(renderIntlLabel('guest_msg_add_success'));
        dispatch(getOrderCustomerInfo({ resvNo }));
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    } finally {
      dispatch(toggleLoading('addMemberLoading'));
    }
  };
};

// 更新入住人、访客
export const orderUpdateMember = (data: IcustomerInfo & IorderItem, isCancel = false) => {
  return async (dispatch) => {
    dispatch(toggleLoading('updateMemberLoading'));
    try {
      const { resvNo, ...rest } = data;
      const res = await fetchUpdateMember({ resvNo, ...rest });
      if (res.code === 0) {
        if (!isCancel) {
          message.success(renderIntlLabel('guest_msg_update_success'));
          dispatch(getOrderCustomerInfo({ resvNo }));
        }
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    } finally {
      dispatch(toggleLoading('updateMemberLoading'));
    }
  };
};

// 更新预订人
export const orderUpdateBooker = (data: IcustomerInfo & IorderItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('updateBookerLoading'));
    try {
      const { resvNo, ...rest } = data;
      const res = await fetchUpdateBooker({ resvNo, ...rest });
      if (res.code === 0) {
        message.success(renderIntlLabel('guest_msg_reserve_update_success'));
        dispatch(getOrderCustomerInfo({ resvNo }));
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    } finally {
      dispatch(toggleLoading('updateBookerLoading'));
    }
  };
};

// 离店
export const orderMemberCheckOut = (data: { id: number } & IorderItem) => {
  return async (dispatch) => {
    const { resvNo, ...rest } = data;
    const res = await fetchMemberCheckOut({ ...rest });
    if (res.code === 0) {
      message.success(renderIntlLabel('guest_msg_leave_shop_success'));
      dispatch(getOrderCustomerInfo({ resvNo }));
    }
  };
};

// 联房详情
export const getUniteRoomDetail = (data: IorderItem) => {
  return async (dispatch) => {
    dispatch(toggleLoading('uniteRoomDetailLoading'));
    let allRoomTypeMap = {};
    // 每个预订或者入住联房号下所有房型、房间id
    const joinRoomNoMap = {};
    // 房型id和房间信息映射
    const roomIdMap = {};
    try {
      const res = await fetchUniteRoomDetail(data);
      // console.log(data);
      // const res = {
      //   code: 0,
      //   data: {
      //     豪华大床房: [
      //       {
      //         joinRoomNo: undefined,
      //         mainStatus: 1,
      //         roomMasterFlag: false,
      //         name: '李雷联房',
      //         roomId: 1,
      //         roomNo: '1100',
      //         roomTypeName: '豪华大床房',
      //         resvNo: '1122VIP',
      //       },
      //       {
      //         joinRoomNo: '1',
      //         mainStatus: 2,
      //         roomMasterFlag: false,
      //         name: '武松',
      //         roomId: 2,
      //         roomNo: '1211',
      //         roomTypeName: '豪华大床房',
      //         resvNo: 'bb',
      //       },
      //       {
      //         joinRoomNo: '1',
      //         mainStatus: 2,
      //         roomMasterFlag: true,
      //         name: '武松',
      //         roomId: 3,
      //         roomNo: '1212',
      //         roomTypeName: '豪华大床房',
      //         resvNo: 'bb',
      //       },
      //     ],
      //     尊享双人房: [
      //       {
      //         joinRoomNo: '1',
      //         mainStatus: 2,
      //         roomMasterFlag: false,
      //         name: '武松',
      //         roomId: 10,
      //         roomNo: '2200',
      //         roomTypeName: '尊享双人房',
      //         resvNo: 'bb',
      //       },
      //       {
      //         joinRoomNo: undefined,
      //         mainStatus: 2,
      //         roomMasterFlag: false,
      //         name: '任志勇',
      //         roomId: 11,
      //         roomNo: '2400',
      //         roomTypeName: '尊享双人房',
      //         resvNo: '11xxx',
      //       },
      //     ],
      //     VIP双人房: [
      //       {
      //         joinRoomNo: '1',
      //         mainStatus: 1,
      //         roomMasterFlag: false,
      //         name: '李雷联房',
      //         roomId: 100,
      //         roomNo: 'k100',
      //         roomTypeName: 'VIP双人房',
      //         resvNo: 'bb',
      //       },
      //     ],
      //   },
      // };
      if (res.code === 0) {
        allRoomTypeMap = get(res, 'data', {});
        Object.keys(allRoomTypeMap)?.forEach((key) => {
          allRoomTypeMap[key]?.forEach((item) => {
            const { joinRoomNo, roomId } = item;
            // uniteKey(预订、入住房间状态+联房号)
            // const uniteKey = mainStatus + joinRoomNo;
            // 每个联房
            if (joinRoomNo && joinRoomNoMap[joinRoomNo]) {
              const roomTypeMap = joinRoomNoMap[joinRoomNo];
              // 每个联房下的房型名称
              if (roomTypeMap[key]) {
                let roomIdList = roomTypeMap[key];
                if (Array.isArray(roomIdList) && roomIdList.length) {
                  roomIdList.push(item.roomId);
                } else {
                  roomIdList = [item.roomId];
                }
                roomTypeMap[key] = roomIdList;
              } else {
                roomTypeMap[key] = [item.roomId];
              }
              joinRoomNoMap[joinRoomNo] = roomTypeMap;
            }
            if (joinRoomNo && !joinRoomNoMap[joinRoomNo]) {
              joinRoomNoMap[joinRoomNo] = { [key]: [item.roomId] };
            }
            // 每个房间id
            roomIdMap[roomId] = item;
          });
        });
      }
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(toggleLoading('uniteRoomDetailLoading'));
      dispatch({
        type: actionType.ALL_ROOM_TYPE_MAP,
        payload: {
          allRoomTypeMap,
          joinRoomNoMap,
          roomIdMap,
        },
      });
    }
  };
};

// 批量获取账务数量
const getUnitRoomInfo = async (list) => {
  const queue = [];
  const result = [];
  try {
    list.forEach((resvNo) => {
      if (resvNo) {
        queue.push(
          fetchBillList({ resvNo })
            .then((res) => res.data.length || 0)
            .catch(() => 0)
            .then((billNum) => {
              result.push({ resvNo, billNum });
            }),
        );
      }
    });
    await Promise.all(queue);
  } catch (_) {
    //
  }
  return result;
};

// 确认联房
export const submitUniteRoom = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('submitUniteRoomLoading'));
    try {
      const unitedRoomInfos = await getUnitRoomInfo(data.fromResvNos);
      const res = await fetchSubmitUniteRoom({ unitedRoomInfos, ...data });
      if (res.code === 0) {
        message.success(renderIntlLabel('order_msg_join_room_success'));
      }
      dispatch(toggleLoading('submitUniteRoomLoading'));
    } catch (error) {
      dispatch(toggleLoading('submitUniteRoomLoading'));
    }
  };
};

// 拆房详情
export const getSplitRoomDetail = (data: { recNos: Array<string> }) => {
  return async (dispatch) => {
    dispatch(toggleLoading('splitRoomDetailLoading'));
    let splitRoomTypeList = [];
    try {
      const res = await fetchSplitRoomDetail(data);
      // const res = {
      //   code: 0,
      //   data: [
      //     {
      //       id: 1,
      //       roomTypeName: '六人房',
      //       roomNo: '1100',
      //       roomId: 1,
      //       status: 3,
      //       certNo: '123',
      //       balance: '120',
      //     },
      //     {
      //       id: 3,
      //       roomTypeName: '双人房',
      //       roomNo: '2300',
      //       roomId: 2,
      //       status: 1,
      //       certNo: '新消息',
      //       balance: '120',
      //     },
      //     {
      //       id: 2,
      //       roomTypeName: '六人房',
      //       roomNo: '1100',
      //       roomId: 1,
      //       status: 3,
      //       certNo: '666',
      //       balance: '990',
      //     },
      //   ],
      // };
      if (res.code === 0) {
        splitRoomTypeList = get(res, 'data', []);
      }
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(toggleLoading('splitRoomDetailLoading'));
      dispatch({
        type: actionType.SPLIT_ROOM_TYPE_LIST,
        payload: {
          splitRoomTypeList,
        },
      });
    }
  };
};

// 拆房提交
export const submitSplitRoom = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('submitSplitRoomLoading'));
    try {
      const res = await fetchSubmitSplitRoom(data);
      if (res.code === 0) {
        message.success(renderIntlLabel('order_msg_split_room_success'));
      }
      dispatch(toggleLoading('submitSplitRoomLoading'));
    } catch (error) {
      dispatch(toggleLoading('submitSplitRoomLoading'));
    }
  };
};

export const initBillList = (params) => {
  return async (dispatch) => {
    dispatch(toggleLoading('billListLoading'));
    try {
      const res = await fetchBillList(params);
      const bills = get(res, 'data', []);
      // flattern array
      const billList = bills.reduce((prev, cur) => {
        return Array.prototype.concat.call(prev, cur, cur.subs || []);
      }, []);
      dispatch({
        type: actionType.BILL_LIST,
        payload: {
          billList,
        },
      });
      dispatch(toggleLoading('billListLoading'));
    } catch (err) {
      dispatch(toggleLoading('billListLoading'));
    }
  };
};

// 获取查房列表
export const getCheckRoomList = (params) => {
  return async (dispatch) => {
    dispatch(toggleLoading('checkRoomListLoading'));
    let checkRoomLogList = [];
    const checkRoomList = [];
    try {
      const res = await fetchCheckRoomList(params);
      if (res.code === 0) {
        checkRoomLogList = get(res, 'data', []);
        if (Array.isArray(checkRoomLogList)) {
          const tempMap = {};
          checkRoomLogList.forEach((item) => {
            const { id, roomId, roomNo, roomTypeName } = item;
            if (!tempMap[roomNo]) {
              tempMap[roomNo] = true;
              checkRoomList.push({ id, roomId, roomNo, roomTypeName });
            }
          });
        }
      }
    } catch (err) {
      //
    } finally {
      dispatch(toggleLoading('checkRoomListLoading'));
      dispatch({
        type: actionType.ORDER_DETAIL_CHECK_ROOM_INFO,
        payload: {
          checkRoomLogList,
          checkRoomList,
        },
      });
    }
  };
};

// 检查房间状态
export const verificationCheckRoom = (params) => {
  return async (dispatch) => {
    try {
      const res = await fetchVerificationCheckRoom(params);
      const list = get(res, 'data', []);
      if (res.code === 0) {
        // list > 0 存在待查房
        return Promise.resolve(list);
      }
      return Promise.reject();
    } catch (err) {
      //
      return Promise.reject();
    }
  };
};

// 申请查房
export const applyCheckRoom = (params) => {
  return async (dispatch) => {
    try {
      const res = await fetchApplyCheckRoom(params);
      if (res.code === 0) {
        message.success(renderIntlLabel('order_msg_has_apply_checkroom'));
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (err) {
      //
      return Promise.reject();
    }
  };
};
